import cleanedFilename from '~/util/cleanedFilename';

export default {
  LINK_DROPDOWN: `${cleanedFilename(__filename)}-link-dropdown`,
};
